import GianlucaAvatar from "../GianlucaAvatar";
import { TutorialResetButton, useTutorial } from "../TutorialGuide";

const TutorialTab = () => {
  const tutorial = useTutorial();

  return (
    <div className="space-y-6">
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6">
        <div className="flex items-center gap-4 mb-6">
          <GianlucaAvatar size="lg" state="idle" withGlow />
          <div>
            <h3 className="font-display text-xl font-semibold text-white">Gian-Luca</h3>
            <p className="text-slate-400">Dein persönlicher Tutorial-Assistent</p>
          </div>
        </div>

        <p className="text-slate-300 mb-6">
          Gian-Luca führt dich Schritt für Schritt durch alle wichtigen Funktionen von MargeVio.
          Das Tutorial umfasst 21 Schritte — von der Panel-Übersicht über Unternehmens-Setup
          bis zu Konto & Abonnement.
        </p>

        <div className="bg-slate-700/50 rounded-lg p-4 mb-6">
          {tutorial && <TutorialResetButton />}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-slate-700/30 rounded-lg p-4">
            <h4 className="text-white font-medium mb-2">Was du lernst:</h4>
            <ul className="text-sm text-slate-400 space-y-1">
              <li>- Unternehmensdaten einrichten</li>
              <li>- Mitarbeiter & Schichtplan</li>
              <li>- Lieferanten & Zutaten</li>
              <li>- Speisen & Getränke kalkulieren</li>
              <li>- HACCP-Checklisten</li>
              <li>- Statistiken & Exporte</li>
            </ul>
          </div>
          <div className="bg-slate-700/30 rounded-lg p-4">
            <h4 className="text-white font-medium mb-2">Funktionen:</h4>
            <ul className="text-sm text-slate-400 space-y-1">
              <li>- Schritte überspringen</li>
              <li>- Fortschritt wird gespeichert</li>
              <li>- Tutorial pausieren & fortsetzen</li>
              <li>- Jederzeit neu starten</li>
              <li>- Hilfreiche Tipps bei jedem Schritt</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TutorialTab;
